import { render, staticRenderFns } from "./More.vue?vue&type=template&id=1c8be7b7&scoped=true"
import script from "./More.vue?vue&type=script&lang=js"
export * from "./More.vue?vue&type=script&lang=js"
import style0 from "./More.vue?vue&type=style&index=0&id=1c8be7b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8be7b7",
  null
  
)

export default component.exports